import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 14.875a.625.625 0 1 1 0 1.25H7.5c-1.44 0-2.023.007-2.48.145a3.375 3.375 0 0 0-2.25 2.25c-.138.457-.145 1.04-.145 2.48a.625.625 0 1 1-1.25 0c0-1.35-.007-2.164.2-2.843a4.625 4.625 0 0 1 3.082-3.083c.68-.206 1.493-.199 2.843-.199H12Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M18.5 13.375a4.125 4.125 0 1 1 0 8.25 4.125 4.125 0 0 1 0-8.25Zm-2.425 2.584a2.875 2.875 0 0 0 2.425 4.416c.567 0 1.095-.168 1.54-.451l-3.965-3.965Zm2.425-1.334a2.86 2.86 0 0 0-1.541.45l3.965 3.965c.284-.446.451-.973.451-1.54a2.875 2.875 0 0 0-2.875-2.875ZM10 2.375a5.125 5.125 0 1 1 0 10.25 5.125 5.125 0 0 1 0-10.25Zm0 1.25a3.875 3.875 0 1 0 0 7.75 3.875 3.875 0 0 0 0-7.75Z"
      clip-rule="evenodd"
    />
  </svg>
`;
